<template lang="html">
  <div class="evaluate">
    <div class="name">总体满意度</div>
    <div class="star">
      <star
        size="biggest"
        v-on:clickStar="getLevel"
        color="#ffc600"
        :canClick="true"
        :score="level"
      />
    </div>
    <div class="level-desc">{{ serveDesc }}</div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'

export default {
  components: {
    star
  },
  props: {
    vorderDetail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      level: 10,
      levelDesc: []
    }
  },
  async created() {
    const descs = await this.$store.dispatch('getReasons')
    this.levelDesc = descs.data.serveStarDesc || []
  },
  methods: {
    getLevel(index) {
      this.level = index
      this.$store.commit('setNewComment', {
        score: index,
        score1: index
      })
      this.$$tracker('110802', '20000', 21065, this.vorderDetail.orderId)
    },
    getDesc(arr, index) {
      if (arr && arr[index]) {
        return arr[index]
      }
      return ''
    }
  },
  computed: {
    ...mapState(['newComment']),
    serveDesc() {
      if (this.levelDesc && this.levelDesc[this.level / 2 - 1]) {
        return `${this.levelDesc[this.level / 2 - 1]}`
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/mixin';
.evaluate {
  height: rem(160px);
  display: flex;
  align-items: center;
  padding-top: rem(53px);
  padding-bottom: rem(53px);

  .name {
    padding-top: rem(5px);
    font-size: rem(28px);
    padding-right: rem(41px);
  }
  .level-desc {
    flex: 1;
    text-align: right;
    font-size: rem(28px);
    color: #666;
  }

  .star {
    line-height: 1;
  }

  // &:last-of-type{
  //     margin-top: 0;
  //     margin-bottom: 0;
  // }
}
</style>
